import { render, staticRenderFns } from "./_manage-preference-page-translation.vue?vue&type=template&id=b543f526"
import script from "./_manage-preference-page-translation.vue?vue&type=script&lang=js"
export * from "./_manage-preference-page-translation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports